var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationCircle = function SvgExclamationCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0m7-2.692c.297 0 .539.24.539.538v2.693a.538.538 0 0 1-1.077 0V7.846c0-.297.24-.538.538-.538m0 5.923a.539.539 0 1 0 0-1.077.539.539 0 0 0 0 1.077",
    clipRule: "evenodd"
  })));
};
export default SvgExclamationCircle;